import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AvanzamentoService} from "../../../_services/avanzamento.service";
import {FilterItem} from "../../../_models/FilterItem";
import {OrganizzazioniService} from "../../../_services/organizzazioni.service";
import {SaveMessage} from "../../../_helpers/save-message";
import {Ordine} from "../../../_models/Ordine";
import {OrdineByBarcode} from "../../../_models/OrdineByBarcode";

@Component({
    selector: 'app-ordine-input',
    templateUrl: './ordine-input.component.html',
    styleUrls: ['./ordine-input.component.scss'],
    standalone: false
})
export class OrdineInputComponent {
@Input() codArt = '';
@Input() codCli = 0;
@Output() ordineChange = new EventEmitter<Ordine>();
ordini: Ordine[] = [];
rifOdP = '';
showOrdine = false;
loading = false;
  constructor(
    private organizzazioneService: OrganizzazioniService,
    private avanzamentoService: AvanzamentoService,
    private saveMessage: SaveMessage) { }

  searchOrdini() {
    const filters: FilterItem[] = [
      {fieldName: 'CodiceArticolo', operazione: 1, value1: this.codArt, value2: '',
        tipoFormControl: null, showColumn: false}
    ];
    if (this.codCli > 0) {
      filters.push({fieldName: 'CodCliente', operazione: 1, value1: this.codCli.toString(), value2: '',
        tipoFormControl: null, showColumn: false});
    }
    this.loading = true;
    this.avanzamentoService
      .getOrdiniByBarcode(this.organizzazioneService.organizzazioneId, false, filters, this.organizzazioneService.filtroOrdini)
      .then((result: OrdineByBarcode) =>  {
        if (result.ordiniCount > 0) {
          this.ordini = result.ordini;  
        }
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento degli ordini."))
      .finally(() => this.loading = false);
  }

  selectOrdine = (ordine: Ordine) => {
    if (!ordine || !ordine.rifOdP) {
      return false;
    }
    this.showOrdine = false;
    this.ordini = [];
    this.rifOdP = ordine.rifOdP;
    this.ordineChange.emit(ordine);
  };
}
